import { render, staticRenderFns } from "./CaseConfigOverview.vue?vue&type=template&id=142bc744"
import script from "./CaseConfigOverview.vue?vue&type=script&lang=js"
export * from "./CaseConfigOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports